
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
directives: {
TransferDom
},
components: {
TransferDom, XDialog
},
props: ['showServiceMenu'],
data () {
return {
showServiceDialog: false
}
},
methods : {
customService () {
this.showServiceDialog = true
}
}
}



// WEBPACK FOOTER //
// ./src/components/menu.vue